export enum ConditionType {
  BasePrice = 'base-price',
  ChangeStyle = 'change-style',
  ColorPrice = 'color-price',
  ComponentSurfaceMargin = 'component-surface-margin',
  CustomCharge = 'custom-charge',
  CustomLevel = 'custom-level',
  CutFee = 'cut-fee',
  DefaultOptions = 'default-options',
  DripEdgeColor = 'drip-edge-color',
  FloorplanCustomGridDimensions = 'floorplan-custom-grid-dimensions',
  ExtraFee = 'extra-fee',
  ExtraFeeMultiLength = 'extra-fee-multi-length',
  LeanCenterHeightDifferenceRule = 'lean-center-height-difference-rule',
  MultiLengthVariablePrice = 'multi-length-variable-price',
  NotificationWhen = 'notification-when',
  OptionComponentEffect = 'option-component-effect',
  OptionExtraFee = 'option-extra-fee',
  OptionReplaceFunction = 'option-replace-function',
  OverrideLineItemDescription = 'override-line-item-description',
  PriceAdjustment = 'price-adjustment',
  PricingVisibility = 'pricing-visibility',
  RoofColor = 'roof-color',
  SceneEnvironmentVisibility = 'scene-environment-visibility',
  SetComponentProperties = 'set-component-properties',
  SetComponentUpgradePrice = 'set-component-upgrade-price',
  SetDialogProperties = 'set-dialog-properties',
  SetOptionProperties = 'set-option-properties',
  SetStyleProperies = 'set-style-properties',
  SetWallFootprintWallProperties = 'set-wall-footprint-wall-properties',
  SidingPrice = 'siding-price',
  TrimLocationColor = 'trim-location-color',
  WallHole = 'wall-hole',
  WallMaximumComponentQuantityRule = 'wall-maximum-component-quantity-rule',
  Webhook = 'webhook',
}
